import { gql } from "@apollo/client";

export const SEND_ORDER = gql`
    mutation Mutation($input: SendOrderInput!) {
        sendOrder(input: $input)
    }
`;
